import { Route } from '@angular/router';
import { analysisRefactorConfigRoutes } from './pages/analysis-configuration/analysis-refactor-configuation.route';

export const analysisRefactorRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/analysis-configuration.component').then(m=>m.AnalysisConfigurationComponent)
  },
  {
    path: 'analysis-configuration',
    children: [...analysisRefactorConfigRoutes]
  }
  
];
